import { Fragment } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Container, Spinner } from "reactstrap";
import { useDataFetch } from "../../Hooks/Use-data-fetch";
import { useAdmin } from "../../../context/AdminContext";
import { ImageSlider } from "../../Components/product/ImageSilder";
import ProductDetails from "../../Components/product/ProductDetails";
import { StatusChip } from "../../Components/common/StatusChip";

export const DatailProduct = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { getData } = useDataFetch();
  const { admin } = useAdmin();

  const { data: productData, isLoading } = getData(["product", id], `/product/${id}`, {
    enabled: !!id,
  });

  const product = productData?.product;

  if (isLoading) {
    return (
      <div className="text-center py-5">
        <Spinner color="primary" /> Cargando producto...
      </div>
    );
  }

  if (!product) {
    return (
      <div className="text-center py-5">
        <h5>No se encontró el producto</h5>
        <button type="button" className="ui-back" onClick={() => navigate(-1)}>
          <i className="ri-arrow-left-line" /> Volver
        </button>
      </div>
    );
  }

  return (
    <Fragment>
      <Container fluid={true} className="ui-content" style={{ padding: 0 }}>
        <button type="button" className="ui-back" onClick={() => navigate(-1)}>
          <i className="ri-arrow-left-line" /> Volver a productos
        </button>

        <div className="ui-detail-head">
          <div>
            <div className="ui-detail-head__id">PRODUCTO</div>
            <div style={{ fontSize: 19, fontWeight: 800, marginTop: 2 }}>{product.title}</div>
          </div>
          <div className="ui-detail-head__chips">
            <StatusChip tone={product.status ? "success" : "danger"} icon={product.status ? "ri-checkbox-circle-line" : "ri-close-circle-line"}>
              {product.status ? "Activo" : "Inactivo"}
            </StatusChip>
          </div>
          <div className="ui-detail-head__actions">
            <button
              type="button"
              style={{ display: "flex", alignItems: "center", gap: 7, border: "none", background: "#4B36F0", color: "#fff", borderRadius: 9, padding: "10px 15px", fontFamily: "inherit", fontSize: 13, fontWeight: 700, cursor: admin?.role === "ASSISTANT" ? "not-allowed" : "pointer", opacity: admin?.role === "ASSISTANT" ? 0.5 : 1 }}
              disabled={admin?.role === "ASSISTANT"}
              onClick={() => navigate(`/product/edit/${product.id}`)}
            >
              <i className="ri-edit-line" /> Editar producto
            </button>
          </div>
        </div>

        <div className="ui-grid-main">
          <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
            <ProductDetails product={product} />
          </div>

          <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
            <div className="ui-card">
              <ImageSlider images={product.images} mainImage={product.mainImage} />
            </div>
            <div className="ui-card">
              <h3 style={{ margin: "0 0 12px", fontSize: 15, fontWeight: 700 }}>Fechas</h3>
              <div className="ui-kv">
                <div className="ui-kv__row">
                  <span className="ui-kv__label">Creado</span>
                  <span className="ui-kv__value">{new Date(product.createdAt).toLocaleString()}</span>
                </div>
                <div className="ui-kv__row">
                  <span className="ui-kv__label">Actualizado</span>
                  <span className="ui-kv__value">{new Date(product.updatedAt).toLocaleString()}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </Fragment>
  );
};
